import React from 'react';
import stl from './PaymentFailure.module.css';
import SvgWhoopsIcon from "../../assets/icons/SvgWhoopsIocn";
import Btn from "../../atoms/Btn";

const PaymentFailure = ({ onRetry }) => {
    return (
        <div className={stl.paymentFailure}>
            <div className={stl.paymentFailureContent}>
                <div className={stl.paymentFailureIcon}>
                    <SvgWhoopsIcon/>
                </div>
                <h1 className={stl.paymentFailureTitle}>Whoops!</h1>
                <p className={stl.paymentFailureMessage}>
                    Something went wrong with your payment
                </p>
                <Btn onClick={onRetry} label='Retry Payment'/>
                <p className={stl.paymentFailureFooterMessage}>
                    If the issue persists, please check your payment method
                </p>
            </div>
        </div>
    );
};

export default PaymentFailure;
